import React from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';

const PotentialCustomerMatches = ({ matchCustomer }) => {
  return (
    <Grid id="offer_member_matches" container justifyContent="flex-end" alignItems="center" direction="row">
      {matchCustomer}
    </Grid>
  );
};

PotentialCustomerMatches.propTypes = {
  matchCustomer: PropTypes.element.isRequired
};

export default PotentialCustomerMatches;
